/**
 * Live speech signal shared between text-to-speech and Anna's avatar.
 * TTS marks word boundaries; the renderer turns them into a voice envelope,
 * so Anna's core pulses with the words she actually says.
 */
interface SignalState {
  speaking: boolean;
  wordAt: number;
  wordLen: number;
}

const signal: SignalState = { speaking: false, wordAt: -1, wordLen: 5 };
const now = () => performance.now() / 1000;

export function markSpeechStart() {
  signal.speaking = true;
  signal.wordAt = -1;
}

export function markSpeechWord(length: number) {
  signal.wordAt = now();
  signal.wordLen = Math.max(1, Math.min(14, length));
}

export function markSpeechEnd() {
  signal.speaking = false;
  signal.wordAt = -1;
}

/** Voice amplitude 0–1 from real word timing, or null when no live signal is available. */
export function speechVoiceLevel(): number | null {
  if (!signal.speaking || signal.wordAt < 0) return null;
  const since = now() - signal.wordAt;
  const duration = 0.12 + signal.wordLen * 0.058;
  if (since < duration) {
    const syllables = Math.max(1, Math.round(signal.wordLen / 3));
    const syl = Math.abs(Math.sin((since / duration) * Math.PI * syllables));
    return 0.3 + 0.7 * syl;
  }
  return Math.max(0.06, 0.3 * Math.exp(-(since - duration) * 6));
}
